import minimize from './minimize';

const isEmpty = (_menu) => {
  return _menu.products.length === 0 && _menu.combos.length === 0;
};

const _createTempQuantities = (_menu) => {
  _menu.products.forEach((p) => (p.tempQuantities = JSON.parse(JSON.stringify(p.quantities))));
};

const clearQuantities = (_menu) => {
  _menu.products.forEach((p) => {
    p.quantity = 0;
  });
  _menu.combos.forEach((c) => (c.quantity = 0));
  // Ripristina le temp quantities ai valori originali di quantities
  _createTempQuantities(_menu)
};

const orderByPosition = (_menu) => {
  _menu.products.sort((a, b) => a.position - b.position);
  _menu.combos.sort((a, b) => a.position - b.position);
};

const total = (_menu) => {
  const p = _menu.products.reduce((sum, item) => {
    return sum + item.quantity * item.price;
  }, 0);
  const c = _menu.combos.reduce((sum, item) => {
    return sum + item.quantity * item.price;
  }, 0);
  return p + c;
};

// If product is unavailable => related combos also
// if menu is available => related products also
// NON IMPLEMENTO QUESTI AUTOMATISMI PER ORA (ANCHE SERVER SIDE VANNO FATTI)

// COME SIDE EFFECT UNAVAILABLE SETTA LA QUANTITA' A 0
const setAvailability = (_menu, id, isAvailable) => {
  const _prod = _menu.products.find((p) => p.id === id);
  if (_prod) {
    _prod.isAvailable = isAvailable;
    _prod.quantity = 0;
    // Check also realted combos
    // _menu.combos.forEach((c) => {
    //   if (c.products.includes(id)) {
    //     c.isAvailable = ...
    //   }
    // });
    return;
  }

  const _combo = _menu.combos.find((c) => c.id === id);
  if (_combo) {
    _combo.isAvailable = isAvailable;
    _combo.quantity = 0;
    return;
  }
  throw new Error('unexpected ' + id);
};
const menuUtils = {
  minimize,
  isEmpty,
  clearQuantities,
  setAvailability,
  total,
  orderByPosition,
};
export default menuUtils;
